module.exports = __webpack_public_path__ + "img/success.2f3d8244.png";